<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">
        Collector
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        hover
        small
        style="font-size:smaller;"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(nomor)="data">{{ data.index +1}}</template>
        <template v-slot:cell(iklan)="data">
          <span v-if="(data.item.iklan==1)">Advertising</span>
        </template>
        <template v-slot:cell(koran)="data">
          <span v-if="(data.item.koran==1)">Newspaper</span>
        </template>
        <template v-slot:cell(action)="data">
          <div class="text-center">
            <a href="javascript:void(0)" @click.stop="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a
              href="javascript:void(0)"
              class="text-danger"
              @click.stop="deleteConfirm(data.item)"
            >
              <i class="fa fa-trash"></i>
            </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label="Limit per page" class="mb-0">
            <b-form-select
              :options="[10, 20, 30, 50, 70, 90, 120]"
              :plain="true"
              v-model="tblData.limit"
              style="width:80px;"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card>
          <div slot="header">Collector - Add/Edit Form</div>
          <b-input-group>
            <b-input-group-prepend>
              <label>Collector Name</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="frmdata.collector_name"
              :state="!$v.frmdata.collector_name.$error"
            ></b-form-input>
          </b-input-group>
          <b-input-group label=".">
            <b-input-group-prepend>
              <label></label>
            </b-input-group-prepend>
            <b-form-checkbox
              class="mt-2"
              v-model="frmdata.iklan"
              value="1"
              unchecked-value="0"
            >Advertising</b-form-checkbox>
            <b-form-checkbox
              class="mt-2"
              v-model="frmdata.koran"
              value="1"
              unchecked-value="0"
            >Newspaper</b-form-checkbox>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Employee</label>
            </b-input-group-prepend>
            <b-form-input readonly v-model="frmdata.crewinfo"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuCrewShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>

          <div slot="footer" style="text-align:center;">
            <button class="btn btn-primary mr-1" @click="save()">
              <i class="fa fa-save"></i> Save
            </button>
            <b-button variant="secondary" class="mr-1" @click="closeFrm()">
              <i class="fa fa-close"></i> Close Form
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      v-model="lkuCrewShow"
      size="lg"
      :hide-footer="true"
      title="List of Employee"
      :centered="true"
      :lazy="true"
    >
      <lku-crew @click="onSelectLkuCrew" :formdata="lkuCrewData"></lku-crew>
    </b-modal>
  </div>
</template>


<script>
import lkuCrew from "../lookup/lkuCrewlazzy";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
      collector_name: { required },
      iklan: { required },
      koran: { required }
    }
  },
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList: true,
      showForm: false,
      showFilter: false,
      lkuCrewData:{},
      lkuCrewShow: false,
      frmdata: { koran: "", collector_name: "", iklan: 0 },
      tblData: {
        tablename: "vwcollector",
        page: 1,
        limit: 20,
        total: 0,

        sortBy: null,
        sortDesc: false,
        customQuery: `koran=1`
      }
    };
  },
  components: { lkuCrew },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "nomor",
          thStyle: "width:50px",
          label: "No."
        },
        {
          key: "collector_name",
          label: "Collector Name",
          sortable: true
        },
        {
          key: "koran",
          label: "Newspaper",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        },
        {
          key: "iklan",
          label: "Advertising",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:100px",
          thClass: "text-center"
        }
      ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    }
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await crud.list(this.tblData);
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.koran = "";
      this.tblData.iklan = "";
      this.tblData.collector_name = "";
      this.refresh();
    },
    add: function(data) {
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      this.frmdata.koran = 1;
      this.showForm = true;
      this.showList = false;
    },
    edit: async function(data) {
      this.model = data;
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      for (var key in this.model) {
        this.frmdata[key] = this.model[key];
      }
      this.frmdata.crewinfo = data.crewnik + " | " + data.crewname;
      this.frmdata.kodelama = data.collector_id;
      let _selected;
      this.showForm = true;
      this.showList = false;
    },
    save: async function(callback) {
      this.frmdata.iklan = this.frmdata.iklan || "0";
      this.frmdata.koran = this.frmdata.koran || "0";
      if (this.invalidFormdata) {
        console.log("validation : ", this.$v.frmdata);
        console.log("frmdata : ", this.frmdata);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          if (this.frmdata.kodelama) {
            await crud.update({
              tablename: "collector",
              key: this.frmdata.kodelama,
              data: {
                collector_id: this.frmdata.collector_id,
                collector_name: this.frmdata.collector_name,
                iklan: this.frmdata.iklan,
                koran: this.frmdata.koran,
                crewkey: this.frmdata.crewkey
              }
            });
          } else {
            await crud.insert({
              tablename: "collector",
              data: {
                collector_id: this.frmdata.collector_id,
                collector_name: this.frmdata.collector_name,
                iklan: this.frmdata.iklan,
                koran: this.frmdata.koran,
                crewkey: this.frmdata.crewkey
              }
            });
          }
          this.closeFrm();
          setTimeout(() => {
            this.refresh();
          }, 500);
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({
        tablename: "collector",
        key: this.model.collector_id
      });
      this.refresh();
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    onSelectLkuCrew: function(lkuData) {
        this.lkuCrewData=lkuData;
        this.lkuCrewShow=false;
      this.frmdata.crewinfo =
        lkuData.selected.crewnik.trim() + " | " + lkuData.selected.crewname.trim();
      this.frmdata.crewkey = lkuData.selected.crewkey;
      this.frmdata.collector_name = lkuData.selected.crewname.trim();
      this.lkuCrewShow = false;
    },
    closeFrm() {
      this.showForm = false;
      this.showList = true;
    },
    close() {
      router.push({name: "koran.home"});
    }
  }
};
</script>
